<div class="route-map-container">
    <div class="selection-container">
        <div class="selection-header">
            <h2>Route Map</h2>
            <p>Select a shape to view on the map.</p>
        </div>
        <div class="form-field-container">
            <mat-form-field appearance="outline" class="map-form-field">
                <mat-label>Route Shape</mat-label>
                <mat-select [formControl]="selectedShape" required>
                    <mat-option>--</mat-option>
                    @for (shape of shapesList; track shape) {
                    <mat-option [value]="shape">{{shape}}</mat-option>
                    }
                </mat-select>
                @if (selectedShape.hasError('required')) {
                <mat-error>Please choose an shape to plot</mat-error>
                }
            </mat-form-field>
        </div>

        <span class="spacer"></span>
        <button mat-flat-button (click)="gotoGTFSBuilder()">Back</button>
    </div>
    @if(showMaps) {
    <div class="map-wrapper">
        <google-map width="100%" [options]="options">
            <map-transit-layer />
            @if(vertices.length > 0) {
            <map-polyline [options]="polylineOptions" />
            @for (point of selectedShapeMarkers; track point) {
            <map-marker [position]="point.position" [label]="point.label" [options]="markerOptions" />
            }
            }
        </google-map>
    </div>
    } @else {
    <div class="data-error">
        <h2>No data available</h2>
        <p>Please upload bus schedule data to view the map.</p>
    </div>
    }

</div>